<template>
  <AdminLayout><UserInputItemsTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import UserInputItemsTable from './UserInputItemsTable.vue';

export default {
  name: 'UserInputItems',
  components: { AdminLayout, UserInputItemsTable },
};
</script>
